<div class="card" *ngIf="data$ | async as data">
  <div *ngFor="let contact of data.contacts" class="contact-container" style="cursor: pointer;">
    <h2 class="contact-name" (click)="toggleDetails(contact)" [class.selected]="contact === selectedContact && !isEditing">
      <button (click)="deleteContact(contact.id)" *ngIf="isEditing" class="btn delete-contact">
        <i class="fa-solid fa-trash"></i>
      </button>
      {{ contact.name }}
    </h2>

    <app-contact-details *ngIf="contact === selectedContact" [contact]="selectedContact!" [isEditing]="isEditing"  (contactUpdated)="updateContact($event)"></app-contact-details>
  </div>

  <div class="card-details">
    <button class="btn add-new-contact-btn" (click)="addNewContactBtn()">Add New Contact</button>

    <form *ngIf="addBtnClicked" (ngSubmit)="addContact()">
      <div class="card-details-input">
        <label for="newContactName">Name:</label>
        <input class="input" type="text" id="newContactName" name="newContactName" [(ngModel)]="newContactName">
      </div>
      <div class="card-details-input">
        <label for="newContactEmail">Email:</label>
        <input class="input" type="text" id="newContactEmail" name="newContactEmail" [(ngModel)]="newContactEmail">
      </div>
      <div class="card-details-input">
        <label for="newContactPhone">Phone:</label>
        <input class="input" type="text" id="newContactPhone" name="newContactPhone" [(ngModel)]="newContactPhone">
      </div>

      <div>
        <button class="btn submit-btn" type="submit">Add Contact</button>
      </div>
    </form>
    <button class="btn edit-btn" (click)="ifEditing()">Edit</button>
    
  </div>
</div>
